import { GcsFile, getGcsUri, idFactory } from "@zickko/shared";
import { ref, uploadString } from "firebase/storage";
import { firebaseStorage } from "../services/firebaseStorage";

export const writeStringToGcs = async (args: {
  contents: string;
  gcsBucket: string;
  gcsFolder: string;
  fileExtension: string;
  contentType: string;
  filename: string;
}): Promise<GcsFile> => {
  const { contents, gcsBucket: bucket, gcsFolder: folder, filename } = args;
  const id = idFactory.createFileId();
  const path = `${folder}`;
  const gcsUri = getGcsUri({ bucket, path });
  const storageRef = ref(firebaseStorage, gcsUri);
  await uploadString(storageRef, contents, "raw", { contentType: args.contentType });
  return {
    id,
    bucket,
    path,
    filename,
  };
};
